class DocumentsScroller {
	constructor($window, $rootScope, $templateCache) {
		this.restrict = 'EA';
		this.scope = {
			twoColumns: '=',
			selectEvent: '&',
			attachments: '=',
			selectedPayment: '='
		};

		this.$window = $window;
		this.$rootScope = $rootScope;
		this.$templateCache = $templateCache;
		this.template = this.loadHtmlTemplate;
		this.link = this.DocumentsScrollerLink;
	}

	get loadHtmlTemplate() {
		const template = this.$templateCache.get('scrollable/documents/documents-scroller-tmpl.html');
		return template;
	}

	init(scope, element, attachments) {
		this.Attachments = attachments;

		scope.offSet = 5;
		scope.animationDuration = 350;
		scope.$element = angular.element(element);
		scope.$scroller = angular.element('[role="group"]', this.$element);

		this.$scope = scope;
		this._registerEventHandling();
	}

	DocumentsScrollerLink(scope, element, attrs) {
		const { attachments: Attachments } = attrs;

		scope.Attachments = Attachments;
		scope.scrollLeft = this.scrollLeft;
		scope.scrollRight = this.scrollRight;
		scope.selectDocument = this.selectDocument;
		scope._performScroll = this._performScroll;
		scope._resetScroller = this._resetScroller;
		scope._getScrollItemWidth = this._getScrollItemWidth;

		this.init(scope, element, Attachments);
	}

	selectDocument(index = -1) {
		let $thisReference;
		while (!$thisReference) {
			let thisReference = this.$parent;
			if ('selectDocument' in thisReference && typeof thisReference.selectDocument === 'function') {
				$thisReference = thisReference;
			} else {
				thisReference = thisReference.$parent;
			}
		}

		$thisReference.attachments.forEach((attachment) => {
			attachment.isSelected = false;
		});

		if ($thisReference.attachments && $thisReference.attachments.length > 0 && index !== -1) {
			$thisReference.attachments[index].isSelected = true;

			$thisReference.selectEvent({ index });
		}
	}

	scrollLeft() {
		this._performScroll('left');
	}

	scrollRight() {
		this._performScroll('right');
	}

	_performScroll(direction) {
		const currentScrollPosition = this.$scroller.scrollLeft();

		let newScrollPosition;
		if (direction === 'left') {
			newScrollPosition = currentScrollPosition - this._getScrollItemWidth();
		} else {
			newScrollPosition = currentScrollPosition + this._getScrollItemWidth();
		}

		this.$scroller.animate({ scrollLeft: newScrollPosition }, this.animationDuration);
	}

	_registerEventHandling() {
		const _scope = this.$scope;
		angular.element('.next-arrow, .next-arrow span', _scope.$element).each((i, ele) => {
			const $ele = angular.element(ele);
			$ele.on('click', (evt) => {
				_scope.scrollRight();
			});
		});

		angular.element('.previous-arrow, .previous-arrow span', _scope.$element).each((i, ele) => {
			const $ele = angular.element(ele);
			$ele.on('click', (evt) => {
				_scope.scrollLeft();
			});
		});

		_scope.$element.closest('.modal').on('show.bs.modal', () => {
			_scope._resetScroller();
		});
	}

	_getScrollItemWidth() {
		const $scrollItem = angular.element(angular.element('button', this.$scroller).get(0));
		const scrollItemWidth = $scrollItem.width();

		return scrollItemWidth + this.offSet;
	}

	_resetScroller() {
		this.attachments.forEach((attachment) => {
			attachment.isSelected = false;
		});

		if (this.attachments && this.attachments.length > 0) {
			this.attachments[0].isSelected = true;
			this.selectEvent({ index: 0 });
		}

		this.$scroller.animate({ scrollLeft: 0 }, this.animationDuration);
	}
}

export default /* @ngInject */ ($window, $rootScope, $templateCache) =>
	new DocumentsScroller($window, $rootScope, $templateCache);
